module.exports = __webpack_public_path__ + "static/media/display-4@768.fc9840e3.png";